import React from 'react';
import { useActions } from '../../hooks/useStore';
import AddTerrainTypeModal from './AddTerrainTypeModal';
import type { TerrainType } from '../../types/types';

interface AddTerrainTypeModalContainerProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Container for AddTerrainTypeModal (ADR-034).
 * Owns store access for the addTerrainType action.
 */
const AddTerrainTypeModalContainer: React.FC<AddTerrainTypeModalContainerProps> = ({ isOpen, onClose }) => {
  const actions = useActions();

  const handleAddTerrainType = async (terrainType: Omit<TerrainType, 'id' | 'createdAt' | 'updatedAt'>) => {
    await actions.addTerrainType(terrainType);
  };

  return (
    <AddTerrainTypeModal
      isOpen={isOpen}
      onClose={onClose}
      onAddTerrainType={handleAddTerrainType}
    />
  );
};

export default AddTerrainTypeModalContainer;
